/**
 * Hero
 * Top banner on the home page with the "Together We Build" headline and the
 * placeholder illustration. Style variant is passed via the HeroStyleClass prop.
 */
import React from 'react';
import './style.css';

const Hero = (props) => {
  return (
    <section className={`hero ${props.HeroStyleClass}`}>
      <div className="hero-slider">
        <div className="slide">
          <div className="container">
            <div className="row">
              <div className="col col-lg-7 slide-caption">
                <div className="slide-top">
                  <span>A Community Project</span>
                </div>
                <div className="slide-title">
                  <h2>
                    Together We Build, Together We <span>Pray</span>
                  </h2>
                </div>
                <div className="slide-subtitle">
                  <p>
                    We&apos;re building Cole Harbour&apos;s first masjid — a
                    place of prayer, learning, and belonging for families across
                    our community. Be part of it.
                  </p>
                </div>
                {/* TODO: Restore the Discover More CTA when we want a hero action again. */}
              </div>
            </div>
          </div>
          <div className="right-vec">
            {/* TODO: Add descriptive alt text for the hero image */}
            <img
              className="mr-20"
              src={props.heroImg}
              alt="Cole Harbour Masjid"
            />
            <div className="right-border">
              <div className="right-icon">
                <i className="fi flaticon-quran"></i>
              </div>
              <div className="right-icon">
                <i className="fi flaticon-taj-mahal-1"></i>
              </div>
              <div className="right-icon">
                <i className="fi flaticon-allah-word"></i>
              </div>
              <div className="right-icon">
                <i className="fi flaticon-muhammad-word"></i>
              </div>
              <div className="right-icon">
                <i className="fi flaticon-prayer"></i>
              </div>
              <div className="right-icon">
                <i className="fi flaticon-business-and-finance"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
